import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';

import type { RootDispatch } from '../../../../configuration/setup/store';
import { fetchContractProductThunk } from '../../common/termedLevel/dialog/renewData.thunk';
import type { TermedLevel } from '../../common/termedLevel/types';
import { CancelFreeContractsButtonContainer } from './CancelFreeContractsButton';
import { ContractPanelHeader } from './ContractPanelHeader';
import { ContractTable } from './ContractTable';
import { parseEnableCancelFreeContractsParameter } from './contractDeepLinkingHook';
import { ManageInManNowButton } from './ManageInManNowButton';
import { mapResourceTypeToProductType } from './mapResourceTypeToProductType';
import { RenewButtonContainer } from './RenewButton';

interface Props {
    contracts: TermedLevel[];
    open: boolean;
    fetchProductDetails?: (productId: string) => void;
}

const ProductDetailsLoader = ({
    productId,
    fetchProductDetails,
}: {
    productId: string;
    fetchProductDetails?: (productId: string) => void;
}) => {
    useEffect(() => {
        if (fetchProductDetails) {
            fetchProductDetails(productId);
        }
    }, [productId, fetchProductDetails]);

    return null;
};

const ContractPanelComponent = (props: Props) => {
    const { contracts, open, fetchProductDetails } = props;
    const { search } = useLocation();
    const productName = contracts[0].productName;
    const productId = contracts[0].productId;
    const productType = mapResourceTypeToProductType(contracts[0].resourceType);
    const isCancelFreeContractsEnabled = parseEnableCancelFreeContractsParameter(search);

    return (
        <ExpanderPanel
            title={
                <ContractPanelHeader
                    productName={productName}
                    productId={productId}
                    numberOfContracts={contracts.length}
                />
            }
            bsStyle='default'
            bodyClassName='padding-0'
            className='ServiceOverviewItem'
            open={open}
        >
            <ProductDetailsLoader productId={productId} fetchProductDetails={fetchProductDetails} />
            <ContractTable
                productId={productId}
                serviceName={productName}
                contracts={contracts}
                resourceType={productType}
            />
            <span className='margin-15 pull-right'>
                <ManageInManNowButton productId={productId} />
                {isCancelFreeContractsEnabled && <CancelFreeContractsButtonContainer productId={productId} />}
                <RenewButtonContainer productId={productId} serviceName={productName} />
            </span>
        </ExpanderPanel>
    );
};

const mapDispatchToProps = (dispatch: RootDispatch) => ({
    fetchProductDetails: (productId: string) => dispatch(fetchContractProductThunk(productId)),
});

export const ContractPanel = connect(null, mapDispatchToProps)(ContractPanelComponent);
